import { OrderMarker } from '@/Enums/OrderMarker';
import { useCallback } from 'react';
import { salesPageActions } from '@/Pages/Sales/services';
import { useDispatch } from 'react-redux';
import { OrderStatusFilterGroups } from 'src/Enums';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { changeDeliveryAsyncActions } from '../services/asyncActions';

export const useAllShippedForm = (orderIds: number[], onClose: () => void) => {
  const dispatch: AppDispatch = useDispatch();

  const submit = useCallback(() => {
    onClose();

    dispatch(
      changeDeliveryAsyncActions.changeDeliveryShippedStatus({
        orderIds,
        orderMarker: OrderMarker.NotShipped,
      }),
    ).then(() => {
      // remove sales from table if current filters is shipped
      dispatch(
        salesPageActions.removeOrdersFromStateByCurrentFilters({
          orderIds: orderIds,
          filters: OrderStatusFilterGroups.ShippedGroup,
        }),
      );
    });
  }, [orderIds]);

  return {
    submit,
  };
};
